module.exports = __webpack_public_path__ + "img/UTGOOS.fad03679.png";